var map = {
	"./PHILIPS-logo.png": 2290,
	"./atvision-logo.png": 6150,
	"./auta-logo.png": 646,
	"./cavin-logo.png": 18,
	"./eona-logo.png": 6622,
	"./gobright-logo.png": 4117,
	"./hibox-logo.png": 987,
	"./iaidea-logo.png": 54,
	"./ipview-logo.png": 3699,
	"./lg-logo.png": 4998,
	"./lifesmart-logo.png": 2620,
	"./mcoms-logo.png": 3210,
	"./mr-logo.png": 9700,
	"./nonius-logo.png": 1581,
	"./plexusav-logo.png": 9389,
	"./prodvx-logo.png": 4112,
	"./qbic-logo.png": 4300,
	"./samsung-logo.png": 6535,
	"./sencore-logo.png": 5534,
	"./unilumin-logo.png": 808,
	"./yeahlink-logo.png": 484,
	"./zafiro-logo.png": 7816
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7632;